// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"AS","cardInnerHeading":"AT","editButton":"AU","formClass":"AV","inputClass":"AW","pw":"AX","enterCurrentPw":"AY","cancelButton":"AZ","submitButton":"A0"};